console.log('calendar.js loaded');

function ajustarAlturaContenedor(selectorContenedor, selectorContenidoActivo) {
    const contenedor = document.querySelector(selectorContenedor);
    const contenidoActivo = document.querySelector(selectorContenidoActivo);

    if (contenedor && contenidoActivo) {
        // Clonar el contenido activo para medir su altura sin posición absoluta
        const clone = contenidoActivo.cloneNode(true);
        clone.style.position = 'static'; // Elimina la posición absoluta
        clone.style.visibility = 'hidden'; // Evita que sea visible
        clone.style.height = 'auto'; // Asegura que la altura se ajuste al contenido
        document.body.appendChild(clone); // Agrega el clon al body para medir

        // Forzar reflujo para asegurar que todo el contenido esté cargado
        clone.offsetHeight;

        const alturaContenido = clone.scrollHeight; // Mide la altura del clon
        document.body.removeChild(clone); // Elimina el clon del DOM

        // Aplica la altura medida al contenedor original
        contenedor.style.height = `${alturaContenido}px`;
        console.log(`Applied height to contenedor: ${alturaContenido}px`);
    }
}


function getMonthName(monthIndex) {
    const monthNames = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    return monthNames[monthIndex];
}

const weekdays = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];
let isFetching = false; // Flag to prevent multiple requests
let selectedDate = null;
let selectedTime = null;
let selectedCabineID = null;
let selectedTimeStart = null;
let selectedTimeEnd = null;

function displayCalendar(month, year) {
    console.log('displayCalendar called', month, year);
    const calendarDays = document.getElementById('calendar-days');
    const currentMonthYear = document.getElementById('current-month-year');
    const availabilityMessage = document.getElementById('availability-message');
    calendarDays.innerHTML = '';
    availabilityMessage.textContent = ''; // Clear the message when the calendar is displayed
    currentMonthYear.textContent = `${getMonthName(month)} ${year}`;

    // Agregar los días de la semana como etiquetas no clickeables
    weekdays.forEach(day => {
        const weekdayLabel = document.createElement('span');  // Cambiado a 'span'
        weekdayLabel.textContent = day;
        weekdayLabel.classList.add('weekday');
        // Prevenir cualquier interacción
        weekdayLabel.addEventListener('click', (e) => e.preventDefault());
        weekdayLabel.addEventListener('mousedown', (e) => e.preventDefault());
        weekdayLabel.addEventListener('keydown', (e) => e.preventDefault());
        calendarDays.appendChild(weekdayLabel);
    });

    const firstDay = new Date(year, month).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    // Ajustar el índice del primer día para que el lunes sea 0
    const adjustedFirstDay = (firstDay + 6) % 7;

    for (let i = 0; i < adjustedFirstDay; i++) {
        const emptyCell = document.createElement('div');
        calendarDays.appendChild(emptyCell);
    }

    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    for (let day = 1; day <= daysInMonth; day++) {
        const dayCell = document.createElement('div');
        dayCell.textContent = day;
        dayCell.dataset.date = `${year}-${month + 1}-${day}`;

        const cellDate = new Date(year, month, day);

        // Habilitar todas las celdas desde la fecha actual hasta 2 meses adelante
        if (cellDate >= today && cellDate <= new Date(currentYear, currentMonth + 2, 0)) {
            dayCell.classList.add('available');
        } else {
            dayCell.classList.add('unavailable');
        }

        // Bloquear la interacción si isFetching es verdadero
        if (isFetching) {
            dayCell.classList.add('disabled');
        }

        calendarDays.appendChild(dayCell);
    }
}

function fetchAvailabilityFromBackend(date) {
    if (isFetching) return Promise.resolve([]); // Evita múltiples solicitudes y retorna una promesa vacía

    isFetching = true;

    const spinner = document.getElementById('spinner');
    const availabilityMessage = document.getElementById('availability-message');
    const timeSlotsContainer = document.getElementById('time-slots-container');
    const calendarDays = document.getElementById('calendar-days');
    const prevButton = document.getElementById('prev-month');
    const nextButton = document.getElementById('next-month');

    // Desactivar el botón de Editar clínica mientras se está buscando disponibilidad
    toggleEditClinicButton(false);
  
    // Deshabilitar botones de navegación
    prevButton.disabled = true;
    nextButton.disabled = true;

    // Poner todos los días como 'unavailable' excepto el día seleccionado
    Array.from(calendarDays.children).forEach(child => {
        if (!child.classList.contains('weekday')) {
            if (child.classList.contains('available') && !child.classList.contains('selected')) {
                child.classList.add('unavailable', 'isfetching');
                child.classList.remove('available');
            } else if (child.classList.contains('selected')) {
                child.classList.add('disabled'); // Bloquear interacción en el día seleccionado
            }
        }
    });

    // Restablecer elementos
    spinner.style.display = 'block';
    availabilityMessage.textContent = '';
    timeSlotsContainer.style.display = 'none';

    // Desplazamiento suave hacia el elemento del spinner
    //spinner.scrollIntoView({ behavior: 'smooth' });

    const myHeaders = new Headers();
    myHeaders.append("Cookie", "connect.sid=s%3AFlY0HiGMyaPg_EesSoqd3eg2hv3OJUAf.wTwNtjd%2Blsw6vkUH0QxtzW0GWIb%2BzPcR4TypZ2F82Zw");

    let service;
    if (collectedData.pack === 'Axila de Regalo - F - 2S') {
        service = 'axilaGratis';
    } else if (collectedData.pack === 'Cuello Anterior de Regalo - M - 2S') {
        service = 'cuelloGratis';
    } else {
        console.error('Unknown pack:', collectedData.pack);
        isFetching = false;
        return Promise.resolve([]); // Retorna una promesa vacía en caso de error
    }

    const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
    };

    const clientToken = collectedData.customerToken;
    const clinicID = collectedData.clinic.code;
    console.log('Client Token:', clientToken);
    console.log('Clinic ID:', clinicID);
    console.log('Date:', date);
    console.log('Headers:', myHeaders);
    console.log('Request Options:', requestOptions);

    return fetch(`https://belenus-shopify-app-2kc8s.ondigitalocean.app/api/check-availability?clientToken=${clientToken}&services=${service}&diaryDate=${date}&ClinicID=${clinicID}`, requestOptions)
        .then(response => {
            console.log('Response:', response);
            return response.json();
        })
        .then(result => {
            console.log('Result:', result);
            spinner.style.display = 'none'; // Ocultar spinner
            isFetching = false;

            // Habilitar botones de navegación
            prevButton.disabled = false;
            nextButton.disabled = false;
            
            // Habilitar el botón de Editar clínica nuevamente al finalizar la carga de datos
            toggleEditClinicButton(true);

            // Restaurar los días que tenían la clase 'isfetching' a 'available'
            Array.from(calendarDays.children).forEach(child => {
                if (child.classList.contains('isfetching')) {
                    child.classList.add('available');
                    child.classList.remove('unavailable', 'isfetching');
                }
                if (child.classList.contains('disabled')) {
                    child.classList.remove('disabled');
                }
            });

            collectedData.productSourceID = result.productSourceID;

            const diaryOptions = result.diaryOptions?.DiaryOptions || [];

            if (diaryOptions.length === 0) {
                availabilityMessage.innerHTML = '<i class="fas fa-exclamation-circle"></i> No hay disponibilidad en la agenda para este día, intenta otro día o cambiando de clínica.';
                timeSlotsContainer.style.display = 'none';
            } else {
                timeSlotsContainer.style.display = 'block';
                
                //ajustarAlturaContenedor('.steps-wrapper', '#step2');

                // Aplicar scrollIntoView al elemento con id time-slots-container
                setTimeout(() => {
                    const timeSlotsContainer = document.getElementById('time-slots-container');
                    if (timeSlotsContainer) {
                        //timeSlotsContainer.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
                        console.log('scrollIntoView aplicado a time-slots-container');
                    } else {
                        console.log('Elemento time-slots-container no encontrado para scrollIntoView');
                    }
                }, 100);
                
            }
            return diaryOptions;
        })
        .catch(error => {
            console.error('Error:', error);
            spinner.style.display = 'none'; // Ocultar spinner
            isFetching = false;

            // Habilitar el botón de Editar clínica aunque haya error
            toggleEditClinicButton(true);

            // Restaurar los días que tenían la clase 'isfetching' a 'available' en caso de error
            prevButton.disabled = false;
            nextButton.disabled = false;

            Array.from(calendarDays.children).forEach(child => {
                if (child.classList.contains('isfetching')) {
                    child.classList.add('available');
                    child.classList.remove('unavailable', 'isfetching');
                }
                if (child.classList.contains('disabled')) {
                    child.classList.remove('disabled');
                }
            });

            return [];
        });
}

// Define isCalendarSetup en el scope global para asegurar que esté accesible
let isCalendarSetup = false;

function setupCalendar() {
    if (isCalendarSetup) return; // Si ya fue ejecutado, no continúa
    isCalendarSetup = true; // Marcar como ejecutado

    console.log('setupCalendar called');

    const calendarContainer = document.getElementById('calendar-container');
    const calendarDays = document.getElementById('calendar-days');
    const currentMonthYear = document.getElementById('current-month-year');
    const timeSlotsContainer = document.getElementById('time-slots-container');
    const timeSlotsList = document.getElementById('time-slots');
    const agendaButton = document.getElementById('agendaButton'); // Asegúrate de que el ID coincida
    const spinner = document.getElementById('spinner');
    let currentMonth = new Date().getMonth();
    let currentYear = new Date().getFullYear();
    const today = new Date();

    displayCalendar(currentMonth, currentYear);

    document.getElementById('prev-month').addEventListener('click', function() {
        if (currentMonth > today.getMonth() || currentYear > today.getFullYear()) {
            if (currentMonth === 0) {
                currentMonth = 11;
                currentYear--;
            } else {
                currentMonth--;
            }
            displayCalendar(currentMonth, currentYear);
        }
    });

    document.getElementById('next-month').addEventListener('click', function() {
        const twoMonthsLater = new Date(today.getFullYear(), today.getMonth() + 2, 0);
        if (new Date(currentYear, currentMonth) <= twoMonthsLater) {
            if (currentMonth === 11) {
                currentMonth = 0;
                currentYear++;
            } else {
                currentMonth++;
            }
            displayCalendar(currentMonth, currentYear);
        }
    });

    calendarDays.addEventListener('click', function(e) {
        if (e.target && e.target.nodeName === "DIV" && e.target.classList.contains('available')) {
            const previouslySelected = calendarDays.querySelector('.selected');
            if (previouslySelected) {
                previouslySelected.classList.remove('selected');
            }

            e.target.classList.add('selected');

            selectedDate = e.target.dataset.date;
            selectedTime = null;
            selectedCabineID = null;
            selectedTimeStart = null;
            selectedTimeEnd = null;
            agendaButton.style.display = 'none';

            fetchAvailabilityFromBackend(selectedDate).then(data => {
                timeSlotsContainer.innerHTML = ''; // Limpiar el contenedor

                const selectElement = document.createElement('select');
                selectElement.id = 'timeSlotsSelect';
                selectElement.name = 'timeSlots';

                const defaultOption = document.createElement('option');
                defaultOption.textContent = 'Selecciona un horario disponible';
                defaultOption.value = '';
                selectElement.appendChild(defaultOption);

                data.forEach(slot => {
                    const option = document.createElement('option');
                    option.textContent = `${slot.TimeStart} - ${slot.TimeEnd}`;
                    option.value = slot.TimeStart;
                    option.dataset.cabine = slot.CabineID;
                    option.dataset.timeStart = slot.TimeStart;
                    option.dataset.timeEnd = slot.TimeEnd;
                    selectElement.appendChild(option);
                });

                timeSlotsContainer.appendChild(selectElement);
                timeSlotsContainer.classList.add('active');

                selectElement.addEventListener('change', function() {
                    const selectedOption = selectElement.options[selectElement.selectedIndex];

                    selectedTime = selectedOption.value;
                    selectedCabineID = selectedOption.dataset.cabine;
                    selectedTimeStart = selectedOption.dataset.timeStart;
                    selectedTimeEnd = selectedOption.dataset.timeEnd;

                    if (selectedTime) {
                        agendaButton.style.display = 'block';
                        agendaButton.style.opacity = '1';
                        agendaButton.disabled = false;
                    } else {
                        agendaButton.style.opacity = '0.5';
                        agendaButton.disabled = true;
                        agendaButton.style.display = 'none';
                    }
                });
            });
        }
    });

    agendaButton.addEventListener('click', function() {
      agendaButton.disabled = true;
      agendaButton.style.opacity = '0.5';
  
      // Validación: asegurarse de que todos los campos estén completos antes de continuar
      if (!selectedDate || !selectedTime || !selectedCabineID) {
          alert('Por favor, completa todos los campos antes de continuar.');
          agendaButton.disabled = false;
          agendaButton.style.opacity = '1';
          return; // Salir de la función si falta algún campo
      }
  
      // Si todos los campos están completos, mostrar el confirm
      if (confirm('¿Estás seguro de que quieres confirmar la cita con los detalles seleccionados?')) {
          console.log('1 click');
          toggleEditClinicButton(false);
          confirmAppointment(); // Confirma la cita y actualiza el DOM
          sendConfirmationData(); // Envía los datos al backend
      } else {
          agendaButton.disabled = false;
          agendaButton.style.opacity = '1';
      }
  });
}

function createNewCustomer() {
    return fetch('https://belenus-shopify-app-2kc8s.ondigitalocean.app/api/newCustomer', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(collectedData)
    })
    .then(response => response.json())
    .then(data => {
        if (data.customerId && data.CustomerToken) {
            console.log('Customer created successfully:', data);
            collectedData.customerId = data.customerId;
            collectedData.customerToken = data.CustomerToken;
        } else {
            console.log('Error creating customer:', data);
            alert('Hubo un error al crear la cuenta. Por favor, inténtalo de nuevo.');
            throw new Error('Error creating customer');
        }
    })
    .catch(error => {
        console.error('Error:', error);
        alert('Hubo un error al crear la cuenta. Por favor, inténtalo de nuevo.');
        throw error;
    });
}

function sendConfirmationData() {
    if (isRequestInProgress) {
        console.log('Solicitud ya en progreso, evitando envío duplicado.');
        return;
    }

    isRequestInProgress = true;
    
    collectedData.agenda = {
        date: selectedDate,
        time: selectedTime,
        cabineID: selectedCabineID,
        timeStart: selectedTimeStart,
        timeEnd: selectedTimeEnd
    };

    console.log('Enviando datos al backend:', collectedData);
    
    const proceedToSendAgenda = () => {
        fetch('https://belenus-shopify-app-2kc8s.ondigitalocean.app/api/newAgenda', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ query: JSON.stringify(collectedData) })
        })
        .then(response => response.json())
        .then(data => {
            console.log('Respuesta del servidor:', data);
            agendaButton.style.opacity = '1'; 
        })
        .catch(error => {
            console.error('Error al enviar los datos:', error);
            alert('Ocurrió un error al procesar la cita. Inténtalo de nuevo.');
            agendaButton.disabled = false;
            agendaButton.style.opacity = '1';
        })
        .finally(() => {
            isRequestInProgress = false;
        });
    };

    if (!collectedData.customerId) {
        createNewCustomer()
        .then(() => {
            proceedToSendAgenda();
        })
        .catch(error => {
            isRequestInProgress = false;
            agendaButton.disabled = false;
            agendaButton.style.opacity = '1';
        });
    } else {
        proceedToSendAgenda();
    }
}

// Función que maneja la activación o desactivación del botón de Editar clínica seleccionada
function toggleEditClinicButton(enable) {
    const button = document.getElementById('editClinicButton');
    if (button) {
        if (enable) {
            button.disabled = false;  // Activa el botón
            button.style.opacity = '1';  // Restaurar opacidad normal
            button.classList.remove('disabled');
        } else {
            button.disabled = true;  // Desactiva el botón
            button.style.opacity = '0.5';  // Reduce opacidad para mostrar que está desactivado
            button.classList.add('disabled');
        }
    } else {
        console.error("Botón de 'Editar clínica seleccionada' no encontrado en el DOM.");
    }
}

function confirmAppointment() {
    console.log('Confirming appointment');
    const calendarContainer = document.getElementById('calendar-container');
    const confirmationMessage = document.getElementById('confirmationMessage');
    const timelineSteps = document.querySelectorAll('.timeline li');

    if (calendarContainer && confirmationMessage && timelineSteps.length >= 3) {
        document.getElementById('step2').style.display = 'none';
        confirmationMessage.style.display = 'block';
        confirmationMessage.classList.add('active');

        timelineSteps[2].classList.add('active');
        timelineSteps[1].classList.remove('active');
        adjustStepsWrapperHeight(confirmationMessage);

        collectedData.agenda = {
            date: selectedDate,
            time: selectedTime,
            cabineID: selectedCabineID,
            timeStart: selectedTimeStart,
            timeEnd: selectedTimeEnd
        };

        actualizarResumenAgendamiento();
        console.log('Datos consolidados:', collectedData);
    } else {
        console.error("Uno o más elementos no están presentes en el DOM");
    }
}


function actualizarResumenAgendamiento() {
    const fechaHoraReserva = document.getElementById('resumenfechaHoraReserva');
    const clinicaDireccion = document.getElementById('resumenclinicaDireccion');
    const clinicaMapa = document.getElementById('resumenclinicaMapa');
    const nombreApellido = document.getElementById('resumennombreApellido');
    const rut = document.getElementById('resumenrut');
    const servicio = document.getElementById('resumenServicio');

    // Extraemos manualmente el año, mes y día de collectedData.agenda.date
    const [year, month, day] = collectedData.agenda.date.split('-');
    const fecha = new Date(year, month - 1, day); // Crear la fecha en horario local

    // Formatear la fecha correctamente
    const fechaFormateada = `${fecha.getDate()} de ${getMonthName(fecha.getMonth())} de ${fecha.getFullYear()}`;

    const elementosFaltantes = [];

    if (!fechaHoraReserva) elementosFaltantes.push('resumenfechaHoraReserva');
    if (!clinicaDireccion) elementosFaltantes.push('resumenclinicaDireccion');
    if (!clinicaMapa) elementosFaltantes.push('resumenclinicaMapa');
    if (!nombreApellido) elementosFaltantes.push('resumennombreApellido');
    if (!rut) elementosFaltantes.push('resumenrut');
    if (!servicio) elementosFaltantes.push('resumenServicio');

    if (elementosFaltantes.length === 0) {
      servicio.textContent = `${collectedData.pack}`;
      fechaHoraReserva.textContent = `${fechaFormateada} - ${collectedData.agenda.timeStart} a ${collectedData.agenda.timeEnd}`;
      clinicaDireccion.textContent = `${collectedData.clinic.name} - ${collectedData.clinic.address}, ${collectedData.clinic.city}`;
      nombreApellido.textContent = `${collectedData.firstName} ${collectedData.lastName}`;
      rut.textContent = collectedData.nif;

      // Mostrar la ubicación en el mapa utilizando Google Maps embebido
      const lat = collectedData.clinic.latitude;
      const lon = collectedData.clinic.longitude;
      const name = encodeURIComponent(collectedData.clinic.name);
  
      const mapUrl = `https://www.google.com/maps?q=${name}@${lat},${lon}&hl=es&z=15&output=embed`;
  
      // Inserta el iframe del mapa
      clinicaMapa.innerHTML = `<iframe width="100%" height="200" frameborder="0" style="border:0; border-radius:10px" src="${mapUrl}" allowfullscreen></iframe>`;
  } else {
      console.error("Los siguientes elementos no están presentes en el DOM:", elementosFaltantes.join(', '));
  }
}


// Call setupCalendar to initialize
setupCalendar();

// Definimos la función addToCalendar aquí
function addToCalendar(calendarType) {
    const eventTitle = 'Cita Médica';
    const eventDescription = `Cita en ${collectedData.clinic.name}`;
    const eventLocation = `${collectedData.clinic.address}, ${collectedData.clinic.city}`;

    // Parse date and time correctly
    const [year, month, day] = collectedData.agenda.date.split('-');
    const [hours, minutes] = collectedData.agenda.time.split(':');
    const eventStart = new Date(year, month - 1, day, parseInt(hours), parseInt(minutes));
    const eventEnd = new Date(eventStart.getTime() + 60 * 60 * 1000); // Assuming 1 hour duration

    let calendarUrl;

    switch (calendarType) {
        case 'ical':
            calendarUrl = `data:text/calendar;charset=utf8,BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
DTSTART:${eventStart.toISOString().replace(/[-:]/g, '').split('.')[0]}Z
DTEND:${eventEnd.toISOString().replace(/[-:]/g, '').split('.')[0]}Z
SUMMARY:${eventTitle}
DESCRIPTION:${eventDescription}
LOCATION:${eventLocation}
END:VEVENT
END:VCALENDAR`;
            window.open(encodeURI(calendarUrl));
            break;
        case 'google':
            calendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(eventTitle)}&dates=${eventStart.toISOString().replace(/[-:]/g, '').split('.')[0]}Z/${eventEnd.toISOString().replace(/[-:]/g, '').split('.')[0]}Z&details=${encodeURIComponent(eventDescription)}&location=${encodeURIComponent(eventLocation)}&sf=true&output=xml`;
            window.open(calendarUrl, '_blank');
            break;
        case 'outlook':
            calendarUrl = `https://outlook.live.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(eventTitle)}&startdt=${eventStart.toISOString()}&enddt=${eventEnd.toISOString()}&body=${encodeURIComponent(eventDescription)}&location=${encodeURIComponent(eventLocation)}`;
            window.open(calendarUrl, '_blank');
            break;
        default:
            console.error("Tipo de calendario no soportado");
    }
}
